<div>
  <div class="mb-3 px-3">
    <div class="message-card">
      <div>
        <mwp-text-translate text="You are making HSA elections for Calendar Year" jsonKey="hsa1" />
        <span>{{ coverageTab.hsaPlanYear }}</span>
      </div>
      @if (coverageTab.hsaDisplayNextPlanYearMessage) {
        <div>
          <mwp-text-translate text="This may be the same as the previous screen or a differing amount." jsonKey="hsa2" />
        </div>
      }
    </div>
  </div>
  <div class="row mb-3 px-3">
    <div class="col-7">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <mwp-text-translate text="The MAXIMUM annual contribution for your" jsonKey="hsa3" />
          <span>{{ coverageTab.hsaPlanYear }}</span>
          <mwp-text-translate text="HSA is:" jsonKey="hsa4" /> 
        </div>
        <div>
          <span class="title-color fw-bold">{{ coverageTab.hsaContributionMax | currency }}</span>
        </div>
      </div>
      @if (!coverageTab.hsaDisplayNextPlanYearMessage) {
        <div class="d-flex justify-content-between mb-3">
          <div>
            <mwp-text-translate text="Year to Date Contribution" jsonKey="hsa5" />
          </div>
          <div>
            <span class="green fw-bold">{{ coverageTab.hsaContributionsYearToDate | currency }}</span>
          </div>
        </div>
      }
      <div class="d-flex justify-content-between mb-3">
        <div>
          <mwp-text-translate text="# of Deductions for " jsonKey="hsa6" />

          <span>{{ coverageTab.hsaPlanYear }}:</span>
        </div>
        <div>
          <span class="green fw-bold">{{ coverageTab.hsaNumDeductionsRemaining }}</span>
        </div>
      </div>
      @if (!coverageTab.hsaDisplayNextPlanYearMessage) {
        <div class="d-flex justify-content-between mb-3">
          <div>
            <mwp-text-translate text="Maximum Remaining Amount Allowed to be Deducted by End of Year " jsonKey="hsa7" />
          </div>
          <div>
            <span class="green fw-bold">{{ coverageTab.hsaContributionMaxRemaining | currency }}</span>
          </div>
        </div>
      }
      <div class="d-flex justify-content-between">
        <div>
          <mwp-text-translate text="First Deduction Date (If Enrolled Today):" jsonKey="hsa8" />
        </div>
        <div>
          <span class="green fw-bold">{{ coverageTab.hsaFirstDeductionDate }}</span>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div class="mb-3">
        <mwp-text-translate text="Enter the amount you want deducted into the Per Pay Cycle Contribution field below." jsonKey="hsa9" />
      </div>
      <div class="mb-3 d-flex justify-content-between align-items-center message-container blue-fill">
        <div>
          <span>{{ coverageTab.hsaFrequencyForDisplay }}
            <mwp-text-translate text="Cycle Contribution" jsonKey="hsa10" />
          </span>
        </div>
        <div>
          <mwp-input [form]="coverageFormGroup" [hideLabel]="true" [nameForControl]="hsaContributionName" [maskType]="maskType.currency" />
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center message-container" [ngClass]="isAnnualContributionValid ? 'green' : 'red'">
        <div>
          <mwp-text-translate text="Estimated Annual Contribution" jsonKey="hsa11" />
        </div>
        <div class="std-font">
          <span class="fw-bold">{{ coverageTab.hsaContributionYearTotalEstimated | currency }}</span>
        </div>
      </div>
    </div>
  </div>
  @if (!isAnnualContributionValid) {
    <div class="px-3 mb-3">
      <div class="message-container red">
        <mwp-text-translate text="Total amount cannot be greater than Maximum Remaining Amount " jsonKey="hsa12" />
        <span> {{ coverageTab.hsaContributionMaxRemaining | currency }}</span>
      </div>
    </div>
  }
  @if (hsaPeroidContribution.hsaDisplayReductionMessage) {
    <div class="px-3 mb-3">
      <div class="message-container warning">
        <div>
          <mwp-text-translate text="Your " jsonKey="hsa13" />
          <span>{{ coverageTab.hsaFrequencyForDisplay }}
            <mwp-text-translate text="cycle contribution would max out your annual allowed contribution before the end of" jsonKey="hsa14" />
            {{ coverageTab.hsaPlanYear }}.
          </span>
        </div>
        <div>
          <mwp-text-translate text="You will have" jsonKey="hsa15" />
          <span class="error">{{ hsaPeroidContribution.hsaReducedNumDeductionsRemaining }}</span>
          <mwp-text-translate text="contributions of" jsonKey="hsa16" />
          <span class="error">{{ hsaPeroidContribution.payPeriodContribution | currency }}</span>
          <mwp-text-translate text="between" jsonKey="hsa17" />
          <span class="error">{{ hsaPeroidContribution.hsaFirstDeductionDate }}</span>
          <mwp-text-translate text="and" jsonKey="hsa18" />
          <span class="error">{{ hsaPeroidContribution.hsaLastFullDeductionDate }}</span>,
          <mwp-text-translate text="and a final contribution of" jsonKey="hsa19" />
          <span class="error">{{ hsaPeroidContribution.hsaContributionReductionAmount | currency }}</span>
          <mwp-text-translate text="on" jsonKey="hsa20" />
          <span class="error">{{ hsaPeroidContribution.hsaDeductionReducedDate }}.</span>
        </div>
      </div>
    </div>
  }
</div>